import { render, staticRenderFns } from "./productCard.vue?vue&type=template&id=f39dbe6c&scoped=true"
import script from "./productCard.vue?vue&type=script&lang=js"
export * from "./productCard.vue?vue&type=script&lang=js"
import style0 from "./productCard.vue?vue&type=style&index=0&id=f39dbe6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39dbe6c",
  null
  
)

export default component.exports